<template>
    <VueCtkDateTimePicker class="datepicker" v-model="daterange" :range="true" lang="ru"
                          color="purple"
                          format="DD.MM.YYYY"
                          formatted="DD.MM.YYYY"
                          output-format="'DD.MM.YYYY'"
                          :noHeader="true"
                          :noShortcuts="true"
                          :noButton="true"
                          :noButtonNow="true"
                          :max-date="this.rangeMaxDate"
                          :autoClose="true"
                          label="Выберите дату" />
</template>

<script>
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import moment from 'moment';

    export default {
        name: "AppDatepickerFilter",
        components: { VueCtkDateTimePicker },
        data() {
            return {
                daterange: null,
                rangeMaxDate: null
            }
        },
        watch: {
            daterange(val) {
                this.$emit('input', val);
            }
        },
        mounted() {
            this.rangeMaxDate = moment().format('YYYY-MM-DD');
        }
    }
</script>

<style scoped>

</style>
